<template>
	<div id="RechargeOrderList" class="border-container" v-if="$auth('recharge-order.list')">
		<a-spin :spinning="loading" v-if="loading" class="loading-incontent"></a-spin>
		<div class="title-container">
			<div class="title-area"><span>充值订单列表</span></div>
			<div class="btn-area">
				<template v-if="type === 1">
					<RechargeOrderExport v-if="$auth('ADMIN')" ghost :type="type" :flagVip="true"/>
					<RechargeOrderExport :type="type" :flagVip="false"/>
				</template>
				<template v-else>
					<RechargeOrderExport v-if="$auth('OPERATOR')" :type="type" :flagVip="false"/>
				</template>
			</div>
		</div>
		<div class="list-container">
			<div class="operate-container">
				<a-row class="search-area" :class="[operateOpen ? 'multi-line' : 'one-line', userType === LOGIN_TYPE.ADMIN ? 'admin' : 'sp']">
					<a-col :xl="16" :lg="24" :md="24" class="search-item time-range-select">
						<div class="key"><span>创建时间:</span></div>
						<div class="value">
							<SelectTime v-model="searchForm.createTime" @change="handleTimeChange('createTime')" />
						</div>
					</a-col>
					<a-col :xl="8" :lg="12" :md="24" class="search-item">
						<div class="key"><span>订单号:</span></div>
						<div class="value">
							<a-input placeholder="请输入订单号" v-model="searchForm.orderSn" @keydown.native.enter="handleSearch"></a-input>
						</div>
					</a-col>
					<!-- <a-col :xl="8" :lg="12" :md="24" class="search-item">
						<div class="key"><span>用户昵称:</span></div>
						<div class="value">
							<a-input placeholder="请输入用户昵称" v-model="searchForm.userName" @keydown.native.enter="handleSearch"></a-input>
						</div>
					</a-col> -->
					<a-col :xl="8" :lg="12" :md="24" class="search-item">
						<div class="key"><span>用户手机:</span></div>
						<div class="value">
							<a-input placeholder="请输入用户手机号" v-model="searchForm.userPhone" @keydown.native.enter="handleSearch"></a-input>
						</div>
					</a-col>
					<a-col :xl="8" :lg="12" :md="24" class="search-item value-select" v-if="$auth('ADMIN')">
						<div class="key"><span>运营商:</span></div>
						<div class="value">
							<SelectOperator placeholder="请选择所属运营商" v-model="searchForm.operator_id" @changed="handleSearch" />
						</div>
					</a-col>
					<a-col :xl="8" :lg="12" :md="24" class="search-item value-select">
						<div class="key"><span>绑定片区:</span></div>
						<div class="value">
							<a-select v-model="searchForm.org_id" show-search option-filter-prop="children" allow-clear @changed="handleSearch" :disabled="!searchForm.operator_id" :placeholder="searchForm.operator_id ? '请选择' : '请先选择运营商'">
								<a-select-option v-for="item of orgList" :key="item.id" :value="item.id" :label="item.name">{{ item.name }}</a-select-option>
							</a-select>
						</div>
					</a-col>
					<a-col :xl="8" :lg="12" :md="24" class="search-item">
						<div class="key"><span>充值卡号:</span></div>
						<div class="value">
							<a-input placeholder="请输入充值卡号" v-model="searchForm.cardUid" @keydown.native.enter="handleSearch"></a-input>
						</div>
					</a-col>
					<a-col :xl="8" :lg="12" :md="24" class="search-item">
						<div class="key"><span>商户单号:</span></div>
						<div class="value">
							<a-input placeholder="请输入" v-model="searchForm.outerSn" @keydown.native.enter="handleSearch" />
						</div>
					</a-col>
					<template v-if="type === 1">
						<a-col :xl="16" :lg="24" :md="24" class="search-item time-range-select">
							<div class="key"><span>退款时间:</span></div>
							<div class="value">
								<SelectTime v-model="searchForm.refundTime" @change="handleTimeChange('refundTime')" />
							</div>
						</a-col>
					</template>
				</a-row>
				<div class="btn-area">
					<a-button type="link" @click="operateOpen = !operateOpen">
						<span
							>{{ operateOpen ? '收起' : '展开' }}
							<a-icon type="down" class="operate-icon" :class="{ up: operateOpen }" />
						</span>
					</a-button>
					<a-button type="primary" @click="handleSearch">查询</a-button>
					<a-button @click="handleSearchReset">重置</a-button>
				</div>
			</div>
			<div class="table-container">
				<a-table :columns="tableColumns | tableFieldsFilter(userType)" :data-source="tableData" :scroll="{ x: true }" :row-key="(record) => record.id" :pagination="false">
					<template>
						<div slot="filter_icon" class="filter_icon"><i class="icon i-dropdown" /></div>
					</template>
					<template>
						<div slot="order_status_filter" class="filter_dropdown" v-if="!type">
							<div v-for="(item, index) of statusList" :key="index" @click="handleFilterChange('orderStatus', item.value)" class="filter_dropdown_item" :class="{ active: searchForm.orderStatus == item.value }">
								{{ item.text }}
							</div>
						</div>
						<div slot="pay_method_filter" class="filter_dropdown">
							<div v-for="(item, index) of payMethodList" :key="index" @click="handleFilterChange('payMethod', item.value)" class="filter_dropdown_item" :class="{ active: searchForm.payMethod == item.value }">
								{{ item.text }}
							</div>
						</div>
						<div slot="card_type_filter" class="filter_dropdown">
							<div v-for="(item, index) of cardTypeList" :key="index" @click="handleFilterChange('cardType', item.value)" class="filter_dropdown_item" :class="{ active: searchForm.cardType == item.value }">
								{{ item.text }}
							</div>
						</div>
						<div slot="settle_status_filter" class="filter_dropdown">
							<div v-for="(item, index) of clearingStatusList" :key="index" @click="handleFilterChange('settleStatus', item.value)" class="filter_dropdown_item" :class="{ active: searchForm.settleStatus == item.value }">
								{{ item.text }}
							</div>
						</div>
					</template>

					<template slot="order_sn" slot-scope="text, record">
						<a-button type="link" @click="routerChange(1, record)" v-if="$auth('recharge-order.detail')">{{ text }}</a-button>
						<span v-else>{{ text }}</span>
					</template>
					<template slot="user_name" slot-scope="text">
						<a-tooltip destroy-tooltip-on-hide :title="text">
							<span class="text-ellipsis" style="maxwidth: 100px">{{ text }}</span>
						</a-tooltip>
					</template>
					<template slot="operator_name" slot-scope="text">
						<a-tooltip destroy-tooltip-on-hide :title="text">
							<span class="text-ellipsis" style="maxwidth: 100px">{{ text }}</span>
						</a-tooltip>
					</template>
					<template slot="price" slot-scope="text">
						<span class="bold">￥{{ text | moneyFilter }}</span>
					</template>
					<template slot="pay_method" slot-scope="text">
						<i class="icon" :class="text | orderPayMethodFormat('icon')" />
						<span>{{ text | orderPayMethodFormat }}</span>
					</template>
					<template slot="settle_status" slot-scope="text">
						<span :style="text | clearingStatusFilter('color')">
							{{ text | clearingStatusFilter }}
						</span>
					</template>
					<template slot="order_status" slot-scope="text">
						<span class="item-status" :class="text | orderStatusFilter('color')">
							<i class="icon i-point" />
							{{ text | rechargeOrderStatusFilter }}
						</span>
					</template>
					<div slot="card_uid" slot-scope="text, record">
						<a-tooltip destroy-tooltip-on-hide :title="text">
							<a-button type="link" @click="routerChange(2, record)" v-if="$auth('card.list')">{{ text }}</a-button>
							<template v-else>{{ text }}</template>
							<!-- <span class="text-ellipsis" style="maxWidth: 190px;" >{{ text }}</span> -->
						</a-tooltip>
					</div>
					<template slot="card_type" slot-scope="text">
						<span>{{ text | rechargeTypeFilter }}</span>
					</template>
					<template slot="card_bind" slot-scope="text">
						<a-tooltip destroy-tooltip-on-hide :title="text">
							<span class="text-ellipsis" style="maxwidth: 120px">{{ text }}</span>
						</a-tooltip>
					</template>
					<template slot="time" slot-scope="text">
						<span>{{ text | timeFilter }}</span>
					</template>
				</a-table>
			</div>
			<div class="paging-container">
				<a-pagination show-quick-jumper show-less-items :show-total="(total) => `共 ${total} 条记录`" :hide-on-single-page="false" :total="total" :current="currPage" :default-page-size="20" @change="pageChange" />
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import Core from '../../core';
const LOGIN_TYPE = Core.Const.LOGIN_TYPE;
const RECHARGE_TYPE = Core.Const.RECHARGE.TYPE;
const CARD_TYPE = Core.Const.RECHARGE.CARD_TYPE;

const tableColumns = [
	{
		key: 'sn',
		title: '订单号',
		dataIndex: 'sn',
		scopedSlots: { customRender: 'order_sn' },
	},
	{
		key: 'user_name',
		title: '用户昵称',
		dataIndex: 'user_name',
		scopedSlots: { customRender: 'user_name' },
	},
	{
		key: 'org_name',
		title: '卡片绑定片区',
		dataIndex: 'org_name',
		scopedSlots: { customRender: 'card_bind' },
	},
	{
		key: 'operator_name',
		title: '运营商',
		dataIndex: 'operator_name',
		scopedSlots: { customRender: 'operator_name' },
		role: [LOGIN_TYPE.ADMIN],
	},
	{
		key: 'price',
		title: '收费金额',
		dataIndex: 'price',
		scopedSlots: { customRender: 'price' },
	},
	{
		title: '付款方式',
		dataIndex: 'pay_method',
		slots: { filterIcon: 'filter_icon' },
		scopedSlots: { customRender: 'pay_method', filterDropdown: 'pay_method_filter' },
	},
	{
		title: '结算状态',
		key: 'settle_status',
		dataIndex: 'clearing_status',
		slots: { filterIcon: 'filter_icon' },
		scopedSlots: { customRender: 'settle_status', filterDropdown: 'settle_status_filter' },
	},
	{
		title: '订单状态',
		dataIndex: 'status',
		key: 'order_status',
		slots: { filterIcon: 'filter_icon' },
		scopedSlots: { customRender: 'order_status', filterDropdown: 'order_status_filter' },
	},
	{
		title: '充值卡号',
		dataIndex: 'card_uid',
		scopedSlots: { customRender: 'card_uid' },
		width: '190px',
	},
	{
		title: '卡类型',
		key: 'card_type',
		dataIndex: 'charge_type',
		slots: { filterIcon: 'filter_icon' },
		scopedSlots: { customRender: 'card_type', filterDropdown: 'card_type_filter' },
	},
	{
		key: 'create_time',
		title: '创建时间',
		dataIndex: 'create_time',
		scopedSlots: { customRender: 'time' },
		width: '190px',
	},
];
export default {
	name: 'RechargeOrderList',
	components: {
        RechargeOrderExport: () => import('./components/RechargeOrderExport.vue'),
	},
	props: {},
	data() {
		return {
			userType: Core.Data.getLoginType(),
			LOGIN_TYPE,
			RECHARGE_TYPE,
			type: 0,
			loading: true,
			// 分页
			currPage: 1,
			total: 0,
			// 搜索
			operateOpen: false,
			defaultTime: Core.Const.TIME_PICKER_DEFAULT_VALUE.B_TO_B,
			searchForm: {
				operator_id: undefined,
				org_id: undefined,
				orderSn: '',
				outerSn: '',
				cardUid: '',
				userName: '',
				userPhone: '',

				settleStatus: '',
				cardType: '',
				orderStatus: '',
				payMethod: '',

				createTime: {
					begin_time: moment().subtract(6, 'd').startOf('D').unix(),
					end_time: moment().endOf('D').unix(),
				},
				refundTime: {}
			},
			orgList: [],
			// 表格
			tableColumns,
			tableData: [],

			statusList: Object.values(Core.Const.RECHARGE.STATUS_MAP),
			payMethodList: Core.Const.PAY.CARD_METHOD_LIST,
			cardTypeList: Object.values(Core.Const.RECHARGE.CARD_TYPE_MAP),
			clearingStatusList: Core.Const.CLEARING.STATUS_LIST,

			exportDisabled: false,
		};
	},
	watch: {
		'searchForm.operator_id': function (newVal) {
			this.getOrgList(newVal);
			this.searchForm.org_id = undefined;
		},
		$route: {
			deep: true,
			immediate: true,
			handler(newRoute) {
				this.type = newRoute.meta.type;
				this.currPage = 1;
				this.searchForm.createTime = {
					begin_time: moment().subtract(6, 'd').startOf('D').unix(),
					end_time: moment().endOf('D').unix(),
				};
				this.getTableData();
			},
		},
	},
	computed: {},
	mounted() {
		this.type = this.$route.meta.type;
		this.getTableData();

		if (!this.$auth('ADMIN')) {
			this.searchForm.operator_id = Core.Data.getUser().id;
		}
	},
	methods: {
		pageChange(curr) {
			// 页码改变
			this.currPage = curr;
			this.getTableData();
		},
		routerChange(type, record) {
			// 路由改变
			console.log('record:', record);
			let routeUrl;
			switch (type) {
				case 1: // 充值订单详情
					routeUrl = this.$router.resolve({
						path: '/recharge-order/order-detail',
						query: {
							id: record.id,
						},
					});
					break;
				case 2: // 卡详情
					let card_type = record.charge_type;
					switch (card_type) {
						case CARD_TYPE.MONEY:
						case CARD_TYPE.TIME:
						case CARD_TYPE.CAR_MONEY:
							card_type = 'reality';
							break;
						case CARD_TYPE.VIRTUAL_MONEY:
						case CARD_TYPE.VIRTUAL_TIME:
						case CARD_TYPE.VIRTUAL_CAR_MONEY:
							card_type = 'virtual';
							break;
					}
					routeUrl = this.$router.resolve({
						path: `/card/${card_type}-card-detail`,
						query: {
							uid: record.card_uid,
						},
					});
					break;
			}
			window.open(routeUrl.href, '_blank');
		},
		handleFilterChange(key, value) {
			this.searchForm[key] = value;
			this.handleSearch();
		},
		handleSearch() {
			// 搜索
			this.pageChange(1);
		},
		handleSearchReset() {
			// 重置搜索
			Object.assign(this.$data.searchForm, this.$options.data().searchForm);
			if (this.$auth('OPERATOR')) {
				this.searchForm.operator_id = Core.Data.getUser().id;
			}
			this.pageChange(1);
		},
		// 计算时间跨度是否大于31天
		handleTimeChange(key) {
			let { begin_time, end_time } = this.searchForm[key];
			let diff = Core.Util.diffOfTime(begin_time, end_time) + 1;
			if (diff > 31) {
				this.$message.warning('请将日期查询范围控制在31天内');
				return true;
			}
			return false;
		},

		getTableData() {
			// 获取 表格 数据
			if (this.handleTimeChange('createTime') || this.handleTimeChange('refundTime')) {
				return;
			}

			this.loading = true;
			let form = Core.Util.deepCopy(this.searchForm);

			Core.Api.RechargeOrder.list(
				this.type,
				this.currPage,
				form.operator_id,
				form.org_id,
				form.orderSn,
				form.outerSn,
				form.userName,
				form.userPhone,
				form.settleStatus,
				form.cardType,
				form.orderStatus,
				form.payMethod,
				form.cardUid,
				form.createTime.begin_time || '',
				form.createTime.end_time || '',
				form.refundTime.begin_time || '',
				form.refundTime.end_time || '',
			)
				.then((res) => {
					console.log('getTableData res', res);
					this.total = res.count;
					this.tableData = res.charge_order_list;
					this.loading = false;
				})
				.catch((err) => {
					console.log('getTableData err', err);
					this.loading = false;
				});
		},

		getOrgList(operator_id) {
			// 获取 选择用 片区 列表
			Core.Api.Org.listName(operator_id).then((res) => {
				console.log('getOrgList res', res);
				this.orgList = res.org_list;
				this.searchForm.org_id = undefined;
			});
		},

		handleExportConfirm(type, flag_vip) {
			// 确认订单是否导出
			let _this = this;
			this.$confirm({
				title: `确认要生成${flag_vip ? "VIP" : ""}导出任务吗？`,
				okText: '确定',
				cancelText: '取消',
				onOk() {
					if (type === 'refund') {
						_this.handleRefundOrderExport(flag_vip);
					} else {
						_this.handleOrderExport();
					}
				},
			});
		},
		handleOrderExport() {
			// 订单导出
			this.exportDisabled = true;

			let form = Core.Util.deepCopy(this.searchForm);

			let exportUrl = Core.Util.getExportUrl('charge-order/export', {
				begin_time: form.createTime.begin_time || '',
				end_time: form.createTime.end_time || '',
				// refund_begin_time: form.refundTime.begin_time || '',
				// refund_end_time: form.refundTime.end_time || '',

				operator_id: form.operator_id ? form.operator_id : '',
				org_id: form.org_id ? form.org_id : '',
				charge_type: form.cardType,
				clearing_status: form.settleStatus,
				status: form.orderStatus,
				pay_method: form.payMethod,
			});
			console.log('handleOrderExport exportUrl', exportUrl);
			window.open(exportUrl, '_blank');
			this.exportDisabled = false;
		},
		handleRefundOrderExport(flag_vip) {
			// 退款订单导出
			this.exportDisabled = true;

			let form = Core.Util.deepCopy(this.searchForm);

			let exportUrl = Core.Util.getExportUrl('export-task/create-charge-order-export', {
				begin_time: form.createTime.begin_time || '',
				end_time: form.createTime.end_time || '',
				refund_begin_time: form.refundTime.begin_time || '',
				refund_end_time: form.refundTime.end_time || '',

				operator_id: form.operator_id ? form.operator_id : '',
				org_id: form.org_id ? form.org_id : '',
				status: form.orderStatus,
				pay_method: form.payMethod,
				clearing_status: form.settleStatus,
				user_name: form.userName,
				card_uid: form.cardUid,
				user_phone: form.userPhone,
				charge_type: form.cardType,
				// type: form.cardType,
				flag_vip: flag_vip ? 1 : 0,
			});
			console.log('handleOrderExport exportUrl', exportUrl);
			window.open(exportUrl, '_blank');
			this.exportDisabled = false;
		},
	},
};
</script>

<style lang="scss" scoped>
#RechargeOrderList {
	.operate-container {
		.btn-area {
			width: 200px;
			transition: 200ms;
			.operate-icon {
				transition: all 0.3s linear;
				&.up {
					transform: rotate(180deg);
				}
			}
		}
		.search-area {
			width: calc(100% - 220px);
			min-width: 300px;
			overflow: hidden;
			transition: height 0.3s ease;
			.search-item {
				.value {
					min-width: 180px;
				}
			}
			&.one-line {
				height: 38px;
			}
			@media (min-width: 992px) {
				// lg 一行两个
				&.multi-line.admin {
					height: calc(38px * 5);
				}
				&.multi-line.sp {
					height: calc(38px * 4);
				}
			}
			@media (min-width: 1200px) {
				// xl 一行三个
				&.multi-line.admin {
					height: calc(38px * 4);
				}
				&.multi-line.sp {
					height: calc(38px * 4);
				}
			}
			@media (max-width: 992px) {
				// lg以下 一行一个
				&.multi-line.admin {
					height: calc(38px * 8);
				}
				&.multi-line.sp {
					height: calc(38px * 7);
				}
			}
		}
	}
	.table-container {
		table span {
			display: inline-block;
		}
		i.icon {
			margin-right: 3px;
		}
	}
}
</style>
